import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quotaIcon'
})
export class QuotaIconPipe implements PipeTransform {
  transform(amount: number, numberAlwaysVisible: boolean): string {
    if (amount > 0) {
      return 'check-framed';
    }

    if (amount === 0 && numberAlwaysVisible) {
      return 'remove';
    }

    return 'attention';
  }
}
